import type { FC, PropsWithChildren } from "react";

import { useFlag } from "@/hooks/use-flag";

export const VisibilityControlledByFeatureFlag: FC<{ featureFlag: string } & PropsWithChildren> = ({
    featureFlag,
    children,
}) => {
    const { value } = useFlag(featureFlag, false);
    return value ? <>{children}</> : null;
};
